'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _assets = require('../../../utils/assets');

var _dyzioFacebookThumbnail = require('../../../components/dyzio-facebook-thumbnail');

var _dyzioFacebookThumbnail2 = _interopRequireDefault(_dyzioFacebookThumbnail);

var _dyzioInstagramThumbnail = require('../../../components/dyzio-instagram-thumbnail');

var _dyzioInstagramThumbnail2 = _interopRequireDefault(_dyzioInstagramThumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GENERIC_MISSING_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';
var GENERIC_STORY_IMAGE = 'https://s3-eu-west-1.amazonaws.com/dyzio-static-files/images/instagram-story2.png';
var TEXT_ASSET = 'https://app.dyzio.co/icons/text-asset.svg';
var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';

var imgThumbnail = {
  width: '100%',
  height: '50px',
  objectFit: 'cover',
  display: 'table-cell',
  verticalAlign: 'middle',
  backgroundColor: '#EEEEEE'
};

var platformIconStyle = {
  width: '100%',
  display: 'inline-table',
  backgroundColor: '#eeeeee',
  paddingTop: 10,
  height: 40
};

var storyImageStyle = {
  width: 60,
  height: 40,
  objectFit: 'cover',
  cursor: 'pointer'
};

var TelegramImageStyle = {
  width: 60,
  height: 40,
  objectFit: 'cover',
  cursor: 'pointer'
};

var TelegramTextImageStyle = {
  width: 20,
  height: 20,
  opacity: '0.5',
  oobjectFit: 'cover',
  cursor: 'pointer'
};

var shouldRenderSupportingDataImage = function shouldRenderSupportingDataImage(asset) {
  var isStory = asset.assetType === 'STORY' || _lodash2.default.get(asset, 'trackedAsset.assetType') === 'STORY';
  var isVK = asset.platform === 'VK';
  var isBlog = asset.platform === 'BLOG';
  var isSnapchat = asset.platform === 'SNAPCHAT';
  return isStory || isVK || isBlog || isSnapchat;
};

var ImageComponent = function ImageComponent(_ref) {
  var post = _ref.post;

  if (post.platform === 'TIKTOK') {
    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        style: storyImageStyle,
        src: post.savedThumbnailUrl
      }),
      content: _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        src: post.savedThumbnailUrl
      })
    });
  }

  if (post.platform === 'TELEGRAM') {
    var thumbnail = post.initialData.thumbnail;

    var imageUrl = 'https://pics.dyzio.co/' + thumbnail;

    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        style: TelegramImageStyle,
        src: imageUrl,
        onError: function onError(i) {
          i.target.src = TEXT_ASSET;
        }
      }),
      content: _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        src: imageUrl,
        onError: function onError(i) {
          i.target.src = TEXT_ASSET;
        }
      })
    });
  }

  var trackedAsset = _lodash2.default.eq(_lodash2.default.get(post, 'type'), 'trackedAssets') ? post : _lodash2.default.get(post, 'trackedAsset');
  var supportingData = trackedAsset.supportingData;


  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  var fp = latestSupportingData && latestSupportingData.filePath;

  var imageSrc = fp ? '' + bucket + fp : GENERIC_STORY_IMAGE;

  if (post.postType === 'post') return _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment', size: 'large', color: 'blue' });

  if (shouldRenderSupportingDataImage(post)) {
    console.log('imageSrc', imageSrc);

    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: (0, _assets.isVideoUrl)(imageSrc) ? _react2.default.createElement(_reactPlayer2.default, { className: 'videoFrame', url: imageSrc, width: '100%', height: '100%' }) : _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        style: storyImageStyle,
        src: fp ? imageSrc : GENERIC_MISSING_IMAGE,
        onError: function onError(i) {
          i.target.src = GENERIC_STORY_IMAGE;
        }
      }),
      content: (0, _assets.isVideoUrl)(imageSrc) ? _react2.default.createElement(_reactPlayer2.default, { className: 'videoFrame', url: imageSrc, width: '50%', height: '50%' }) : _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        style: storyImageStyle,
        src: fp ? imageSrc : GENERIC_MISSING_IMAGE,
        onError: function onError(i) {
          i.target.src = GENERIC_STORY_IMAGE;
        }
      })
    });
  }

  if (trackedAsset.assetType === 'TEXT' && trackedAsset.imageURL) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: trackedAsset.assetURL },
          _react2.default.createElement(_semanticUiReact.Image, {
            src: trackedAsset.imageURL,
            style: imgThumbnail,
            size: 'mini',
            floated: 'left'
          })
        ),
        content: 'view post on ' + _lodash2.default.toLower(trackedAsset.platform)
      })
    );
  }

  var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
  var mainTweetMedia = _lodash2.default.head(tweetMedia);
  var tweetThumbnail = _lodash2.default.get(mainTweetMedia, 'media_url');

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(
        'a',
        { target: '_blank', rel: 'noopener noreferrer', href: trackedAsset.assetURL },
        post.facebookId && _react2.default.createElement(_dyzioFacebookThumbnail2.default, { assetId: post.facebookId }),
        post.instagramId && _react2.default.createElement(_dyzioInstagramThumbnail2.default, {
          assetId: post.instagramId,
          savedMediumImageUrl: trackedAsset.savedThumbnailUrl || trackedAsset.savedMediumImageUrl,
          trackedAssetId: trackedAsset.id
        }),
        tweetThumbnail && _react2.default.createElement(_semanticUiReact.Image, {
          src: tweetThumbnail,
          style: imgThumbnail,
          size: 'mini',
          floated: 'left'
        }),
        !post.facebookId && !post.instagramId && !tweetThumbnail && post.thumbnail && _react2.default.createElement(_semanticUiReact.Image, {
          src: post.thumbnail,
          style: imgThumbnail,
          size: 'mini',
          floated: 'left'
        }),
        !post.thumbnail && _react2.default.createElement(
          'div',
          { style: platformIconStyle },
          _react2.default.createElement(_semanticUiReact.Icon, {
            name: _lodash2.default.toLower(trackedAsset.platform)
          })
        )
      ),
      content: 'view post on ' + _lodash2.default.toLower(trackedAsset.platform)
    })
  );
};

exports.default = ImageComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/image-component.js
 ** module id = 968
 ** module chunks = 0
 **/